import { render, staticRenderFns } from "./rectificationOrder.vue?vue&type=template&id=4be20fe3&scoped=true&"
import script from "./rectificationOrder.vue?vue&type=script&lang=js&"
export * from "./rectificationOrder.vue?vue&type=script&lang=js&"
import style0 from "./rectificationOrder.vue?vue&type=style&index=0&id=4be20fe3&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4be20fe3",
  null
  
)

export default component.exports